import { useEffect, useState } from 'react';

/**
 * Trailing-edge debounce for derived values (e.g. filter objects that feed
 * expensive tile URLs). The first value is emitted immediately; subsequent
 * changes settle after `delayMs` of quiet.
 */
export function useDebouncedValue<T>(value: T, delayMs = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
